import APP from 'src/main.js'
import Event from './Event.js'

class RefundExpected extends Event {
  get refund_cancel(){
    let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.parent_id === this.id)&&(rel.child_type==='RefundCancel'))||{}).child_id
    if(value){
      return this.constructor.employeeStore.events.find(ev => (ev.id === value)&&ev.id)
    } else {
      return null
    }
  }
  get refund(){
    return (this.refund_cancel||{}).income_received
  }

  get linked(){
    return this.refund_cancel != null
  }

  // RefundExpected should always be matched with a Refund
  get should_be_linked() {
    return true
  }
}
export default RefundExpected
